import { styled } from '@mui/system'
import { ReactComponent as ChatSvg } from '@app/assets/chat.svg'
import { ReactComponent as BellSvg } from '@app/assets/bell_2.svg'
import { ReactComponent as SearchSvg } from '@app/assets/search.svg'

interface SlideMenuNavigationProps {
	readonly minimize?: boolean
}

const SlideMenuNavigation = styled('nav', {
	shouldForwardProp: props => props !== 'minimize',
})<SlideMenuNavigationProps>(({ minimize }) => ({
	flexGrow: 1,
	position: 'relative',
	paddingTop: minimize ? '2rem' : '1.4rem',
	overflow: 'auto',
	marginRight: minimize ? '-1.0625rem' : '-0.625rem',
	paddingRight: minimize ? '1.0625rem' : '0.625rem',
	'& button, & a': minimize && {
		color: 'transparent',
	},
}))

const SidebarChatIcon = styled(ChatSvg)(({ theme }) => ({
	width: '1.25rem',
	minWidth: '1.25rem',
	marginRight: '1.05rem',
	marginLeft: '0.25rem',
	'& path': {
		fill: `${theme.palette.primary.main} !important`,
	},
}))

const SidebarAlertIcon = styled(BellSvg)`
	min-width: 1.3125rem;
	margin-right: 1rem;
	margin-left: 0.25rem;
`

const SidebarSearchIcon = styled(SearchSvg)(({ theme }) => ({
	minWidth: '1.3125rem',
	marginRight: '1rem',
	marginLeft: '0.25rem',
	'& path': {
		fill: `${theme.palette.primary.main} !important`,
	},
}))

export {
	SidebarChatIcon,
	SidebarAlertIcon,
	SidebarSearchIcon,
	SlideMenuNavigation,
}
